<template>
  <ui-route-aware-modal-container
    :id="LEAVE_SERVICE_CREATE_MODAL_ID"
    :size="UI.SIZE.SMALL"
    :fallback-route="parentRoute"
    focus="input[name='name']"
    no-header
    no-footer
  >
    <template #default="{ hideModalAndGoToRoute }">
      <details-form
        v-bind="{
          submitCallback: (data) => createCallback(data, hideModalAndGoToRoute),
          searchApproverCallback,
          isPending
        }"
      />
    </template>
  </ui-route-aware-modal-container>
</template>

<style lang="sass" scoped>
@import '~/assets/sass/modules/layout/members'
@import '~/assets/sass/modules/layout/variables'

$left-column-width: 380px

.page-create

  &__main
    padding: $layout-spacer-y $layout-spacer-x

  &__details
    width: $left-column-width

</style>

<style lang="sass">
// @XXX Vue3 lack of State-Driven Dynamic CSS API
#leave-service-create-modal-id
  // (stacked effect, as an inner small modal can be opened on top of this one)
  $width: calc(#{$modal-sm} + 32px)

  .modal-dialog
    max-width: $width

</style>

<script lang="ts">
import DetailsForm from '~/components/transat/service/details/DetailsFormCreate.vue'
import Console from '~/utils/lib/core/console'
import { join, noop, sustainedPromise, tapCatch, toString } from '~/utils/lib/core/prelude'
import { MENU_ITEM, NAVIGATION_SCOPE } from '~/utils/lib/layout/types'
import { getListRoute, getDetailsRoute } from '~/stores/transat/service'
import { useToastBuilder } from '~/composables/layout/toast'
import { useCompanyRequiredNavigationContext } from '~/composables/layout/navigation'
import { useStore_transat_service_details } from '~/stores/transat/service/details'
import { useStore_transat_approver_list } from '~/stores/transat/approver/list'
import { EVENTS } from '~/stores/transat/service/list'

const console = new Console('component:service-create')

const LEAVE_SERVICE_CREATE_MODAL_ID = `leave-service-create-modal-id`

export default defineNuxtComponent({
  components: { DetailsForm },
  setup() {
    definePageMeta({
      navigationScope: NAVIGATION_SCOPE.COMPANY_REQUIRED,
      menuItem: MENU_ITEM.ABSENCES,
    })
    const navigationContext = useCompanyRequiredNavigationContext()

    useHead({
      title: join(' ', [
        `Équipe → ajout`,
        `— ${navigationContext.fromCompanyLevel().company.raison_sociale}`,
      ]),
    })

    const triggeredParentListRefresh
      = inject(EVENTS.ON_SERVICE_LIST_REFRESH_NEEDED, noop)

    const ToastBuilder = useToastBuilder()

    const parentRoute = getListRoute(
      navigationContext.fromCompanyLevel().structure.id,
      navigationContext.fromCompanyLevel().company.code_societe
    )

    const store_service_details = useStore_transat_service_details()
    const store_approver_list = useStore_transat_approver_list()

    return {
      ...navigationContext,
      ToastBuilder,
      store_service_details,
      store_approver_list,
      parentRoute,
      triggeredParentListRefresh,
    }
  },
  data() {
    return {
      LEAVE_SERVICE_CREATE_MODAL_ID,
      isPending: false,
    }
  },
  methods: {
    createCallback(data, hideModalAndGoToRoute) {
      const opts = {
        data,
        uuidData: this.fromCompanyLevel().structure.uuidData,
        code_societe: this.fromCompanyLevel().company.code_societe
      }

      this.isPending = true

      return sustainedPromise(
          300,
          this.store_service_details.create(opts)
        )
        .then(({ uuidTeam }) => {
          const {
            structure: { id },
            company: { code_societe }
          } = this.fromCompanyLevel()
          const url = getDetailsRoute(id, code_societe, uuidTeam)

          this.triggeredParentListRefresh()

          hideModalAndGoToRoute(url, () => {
            this.ToastBuilder
              .success()
              .title(`Équipe ajoutée !`)
              .show()
          })
        })
        .catch(err => {
          this.isPending = false

          console.warn('createCallback', err)
          this.ToastBuilder
            .error(toString(err))
            .title(`Ajout équipe`)
            .show()
        })
    },
    searchApproverCallback() {
      const opts = {
        uuidData: this.fromCompanyLevel().structure.uuidData,
        code_societe: this.fromCompanyLevel().company.code_societe,
      }

      return this.store_approver_list.read(opts)
        .catch(tapCatch(err => {
          console.warn('searchApproverCallback', err)
          this.ToastBuilder
            .error(toString(err))
            .title(`Recherche d'utilisateurs`)
            .show()
        }))
    },
  }
})
</script>
